var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasExtencion('filtrar_clientes_por_sucursal_en_vender'))?_c('div',[_c('horizontal-nav',{staticClass:"m-b-15",attrs:{"items":_vm.items,"set_sub_view":"","show_display":false}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }